<template>
  <div class="input-wrapper" v-if="tipo === 'text'">
    <label for="field_value">{{ nombre }}</label>
    <div style="height: 100%; align-content: flex-end">
      <v-textarea
        dense
        v-model="field_value"
        :rules="required ? RULES.REQUIRED : []"
        hide-details="auto"
        :rows="5"
        :outlined="outlined"
        :no-resize="true"
        :disabled="disabled"></v-textarea>
    </div>
  </div>
  <div class="input-wrapper" v-else-if="tipo === 'character'" :disabled="disabled">
    <label for="field_value">{{ nombre }}</label>
    <div style="height: 100%; align-content: flex-end">
      <v-text-field
        dense
        :key="componentKey"
        :rules="required ? RULES.REQUIRED : []"
        v-model="field_value"
        :outlined="outlined"
        :disabled="disabled"
        hide-details="auto"></v-text-field>
    </div>
  </div>
  <div class="input-wrapper" v-else-if="tipo === 'int'">
    <label for="field_value">{{ nombre }}</label>
    <div style="height: 100%; align-content: flex-end">
      <v-text-field
        type="number"
        dense
        :key="componentKey"
        :rules="RULES.REQUIRED.concat(RULES.NUMBER)"
        :outlined="outlined"
        v-model="field_value"
        hide-details="auto"></v-text-field>
    </div>
  </div>
  <div class="input-wrapper" v-else-if="tipo === 'decimal'">
    <label for="field_value">{{ nombre }}</label>
    <div style="height: 100%; align-content: flex-end">
      <v-text-field
        type="text"
        inputmode="decimal"
        dense
        :key="componentKey"
        :rules="(required ? RULES.REQUIRED : []).concat(RULES.DECIMAL)"
        v-model="field_value"
        :outlined="outlined"
        :disabled="disabled"
        hide-details="auto"></v-text-field>
    </div>
  </div>
  <div class="input-wrapper" v-else-if="tipo === 'tinyint'">
    <label for="field_value">{{ nombre }}</label>
    <div style="height: 100%; align-content: flex-end">
      <v-checkbox dense v-model="field_value" hide-details="auto"></v-checkbox>
    </div>
  </div>
  <div class="input-wrapper" v-else-if="tipo === 'date'">
    <label for="field_value">{{ nombre }}</label>
    <div style="height: 100%; align-content: flex-end">
      <v-menu
        ref="campo_fecha_picker"
        v-model="ui.fecha_picker"
        :return-value.sync="field_value"
        :close-on-content-click="false"
        :key="componentKey"
        transition="scale-transition"
        offset-y
        min-width="auto">
      </v-menu>
    </div>
  </div>
  <div class="input-wrapper" v-else-if="tipo === 'time'">
    <label for="field_value">{{ nombre }}</label>
    <div style="height: 100%; align-content: flex-end">
      <v-menu
        ref="time_picker"
        v-model="ui.time_picker"
        :return-value.sync="field_value"
        :close-on-content-click="false"
        :nudge-right="40"
        :key="componentKey"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px">
      </v-menu>
    </div>
  </div>
  <div class="input-wrapper" v-else-if="tipo === 'titulo'">
    <label>{{ nombre }}</label>
    <v-card-subtitle class="px-0 pb-2"></v-card-subtitle>
    <v-divider class="mt-0 mb-4"></v-divider>
  </div>
  <div class="input-wrapper" v-else-if="tipo === 'estatico'">
    <label for="field_value">{{ nombre }}</label>
    <div style="height: 100%; align-content: flex-end">
      <SelectEstaticos
        dense
        v-model="field_value"
        :key="componentKey"
        :codigo="estatico ? estatico.codigo : ''"
        :multiple="multiple"
        :required="required"
        :subalcance="subalcance"
        :item-text="'texto'"
        :item-value="'texto'"
        :return-object="false" />
    </div>
  </div>
  <div class="input-wrapper" v-else-if="tipo === 'emplazamiento'">
    <label for="field_value">{{ nombre }}</label>
    <div style="height: 100%; align-content: flex-end">
      <SelectEmplazamientos
        dense
        v-model="field_value"
        :tipo="'tipos-de-direccion'"
        :key="componentKey"
        :user="cliente"
        :multiple="multiple"
        :subalacance_tipo="subalacance_tipo"
        required
        :label="false" />
    </div>
  </div>
  <div class="input-wrapper" v-else-if="tipo === 'yesno'">
    <label for="field_value">{{ nombre }}</label>
    <div style="height: 100%; align-content: flex-end">
      <v-select
        dense
        v-model="field_value"
        :items="itemsSelectYesNo"
        item-text="text"
        item-value="value"
        :key="componentKey"
        :outlined="outlined"
        :placeholder="$t('generales.seleccione')"
        :rules="required ? RULES.BOOLEAN : []"
        :required="required"></v-select>
    </div>
  </div>
</template>

<script>
import RULES from '~/models/form.rules'
import SelectEstaticos from '~/components/forms/SelectEstaticos.vue'
import SelectEmplazamientos from '~/components/forms/SelectEmplazamientosObject.vue'

export default {
  name: 'CampoFormulario',
  props: {
    tipo: { type: String, default: '' },
    nombre: { type: String, default: '' },
    valor: { type: null, default: '' },
    estatico: { type: Object, default: null },
    cliente: { type: Object, default: null },
    multiple: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    subalacance_tipo: { type: String, default: '' },
    subalcance: { type: Object, default: null },
    isNew: { type: Boolean, default: false },
    outlined: { type: Boolean, default: true },
  },
  components: { SelectEstaticos, SelectEmplazamientos },

  data() {
    return {
      field_value: this.multiple ? [] : '',
      itemsSelectYesNo: [
        { text: this.$t('generales.si'), value: 1 },
        { text: this.$t('generales.no'), value: 0 },
      ],
      RULES,
      ui: { loading: false, isValid: false, time_picker: false, fecha_picker: false },
      componentKey: 0,
    }
  },

  watch: {
    valor(val) {
      if (val && typeof val === 'object' && val.linkEstaticoValue) {
        this.field_value = val.value
        return
      }
      if (this.multiple) {
        this.field_value = Array.isArray(val) ? val : (val ? [val] : [])
      } else {
        this.field_value = Array.isArray(val) ? val[0] : val
      }
      if (this.tipo === 'yesno' || this.tipo === 'tinyint') {
        this.field_value = Array.isArray(val) ? val[0] : val
      }
    },
    field_value(value) {
      if (this.tipo === 'emplazamiento') {
        if (!this.multiple) {
          if (Array.isArray(value)) value = value[0]
          if (typeof value === 'object' && this.subalacance_tipo !== 'grid') {
            value = value?.uuid
          }
        }
      }
      if (!this.multiple) {
        if (['tinyint', 'character', 'decimal', 'text', 'estatico'].includes(this.tipo)) {
          value = Array.isArray(value) ? value[0] : value
        }
      }
      if (this.tipo === 'decimal' && typeof value === 'string') {
        value = value.replace(',', '.')
      }
      this.emitChange(value)
    },
  },

  methods: {
    async init() {
      if (this.tipo === 'tinyint' && this.valor === '') {
        this.field_value = false
      }
    },
    emitChange(value) {
      if (value !== null) {
        this.$emit('change', value)
        this.$emit('input', value)
      }
    },
  },

  mounted() {
    const v = this.valor
    if (v && typeof v === 'object' && v.linkEstaticoValue) {
      this.field_value = v.value
    } else {
      if (this.multiple) {
        this.field_value = Array.isArray(v) ? v : (v ? [v] : [])
      } else {
        this.field_value = Array.isArray(v) ? v[0] : v
      }
    }
    this.init()
  },
}
</script>


<style scoped>
.input-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
